import React from 'react'

import { Box, H4 } from '@allied-solutions/affinity'

const Section = ({ children, heading, fullWidth, ...rest }) => (
  <Box
    py={15}
    px={fullWidth && [null, null, null, 17]}
    mx={fullWidth && [null, null, null, -17]}
    position="relative"
    css={`
      & + & {
        border-top: 1px solid ${props => props.theme.colors.mutedLine};
      }

      &:last-child {
        padding-bottom: 0;
      }
    `}
    {...rest}
  >
    {heading && (
      <H4 typeStyle="titleSmall.bold" textAlign="left" mb={-4}>
        {heading}
      </H4>
    )}
    {children}
  </Box>
)

export { Section }
